import { GridFilterItem } from "@mui/x-data-grid/models/gridFilterItem";
import { config } from "../config/utils";

export interface QueryParam {
  name: string;
  value: string[];
}

export const toQueryParams = (
  filterItems: GridFilterItem[] = [],
  queryParams: QueryParam[] = []
) => {
  const filters = filterItems
    .filter((item) => item.field && item.value)
    .map((item) => ["filter", `${item.field}::${item.value}`]);
  const query = queryParams
    .flatMap((item) => item.value.map((it) => `${item.name}::${it}`))
    .map((item) => ["filter", item]);
  return new URLSearchParams([...filters, ...query]);
};

export const getTesterFiles = async (
  page = 0,
  size = 20,
  filterItems: GridFilterItem[],
  queryParams: QueryParam[],
  state: object
) => {
  try {
    const params = toQueryParams(filterItems, queryParams);
    const response = await fetch(
      `${config.server}/vehicle-tests?page=${page}&size=${size}&${params}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("idToken")}`
        }
      }
    );
    verifyStatus(response.status, state);
    return await response.json();
  } catch (error) {
    return { list: [], count: 0 };
  }
};

export const getCheckedRowsFiles = async (ids: string[]): Promise<any> => {
  const response = await fetch(`${config.server}/vehicle-tests/findAllBy`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${localStorage.getItem("idToken")}`
    },
    body: JSON.stringify(ids),
  });
  verifyStatus(response.status, {});
  return await response.json();
};

const verifyStatus = (status: number, state: object) => {
  if (status === 401 || status === 403) {
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    window.location.href = `${config.server}/auth/login?state=${btoa(JSON.stringify(state))}`;
  }
}